import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import GameComponent from "game/app/components/game/game-component";
import {Link} from "react-router-dom";
import CreativeTaskForm from "../../../common/creative-task-form";
import {submitCreativeTask} from "game/app/actions/creative-tasks-actions";
import assets from "game/app/assets";
import GameInstance from "common/models/game-instance";
import VideoBtn from "game/app/components/video-btn";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";

class Categories extends GameComponent {

    constructor(props) {
        super(props);
        this.state = { instanceId: null }
    }

    componentWillMount() {
        const instanceId = this.props.gameInstance.instance.id;
        this.setState({...this.state, instanceId: instanceId});
    }

    submitCreativeTask = (task) => {
        return (values, form) => {
            this.props.submitCreativeTask(this.getInstanceId(), task.id, values)
        }
    };

    renderCategory(category_id, about) {
        let list = this.props
            .knowledgeQuestions
            .list
            .filter((item) => item.properties.category === category_id);

        let questionIds = new Set();

        list.forEach((item) => {
            questionIds.add(item.id);
        });

        let categoryAnswers = this.props.gameInstance.instance.answers.filter((item) => {
            return questionIds.has(item.luduengine_knowledge_question_id);
        });

        let btnClass = 'btn btn-block ';
        btnClass += (categoryAnswers.length === list.length ? 'btn-success ' : 'btn-primary ');

        return (
            <div className='col-md-6 col-xl-4 text-center'>
                <div className='card'>
                    <div className='card-body'>
                        <img src={assets['categories'][category_id]} className='img-fluid'/>
                        <h5>{GameInstance.getCategoryTitle(category_id)}</h5>
                        <p>{about}</p>
                        <p>Základní úkoly { categoryAnswers.length } / { list.length }</p>
                        <Link to={`/game/${this.props.gameInstance.instance.id}/round-3/otazky/${category_id}`} className={btnClass}>Zobrazit</Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.knowledgeQuestions.loading)
            return (<div>Loading</div>);

        let completed = this.getInstanceProperty('ROUND_3_COMPLETED');

        let creativeTasks = this.props.creativeTasks.list
            .filter((task) => task.node === 'Nodes::Round03Node')
            .map((task) => (<CreativeTaskForm key={task.id} resource={task} handleSubmit={this.submitCreativeTask(task)} active={!completed}/>));

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <div className='separate-bottom text-ceter'>
                            <h1 className='page-title-minor separate-bottom'>Úkoly</h1>
                            <p>Úkoly jsou rozděleny do několika kategorií. Po jejím rozkliknutí se vám zobrazí jednotlivé otázky.</p>
                            <p>Podívejte se na naše videa o vánocích a investicích, aby ste lépe pochopili jejich specifika a dopad na váš rozpočet.</p>
                            <div>
                                <VideoBtn videoId='dYgG4jAcw1M'><FontAwesomeIcon icon={['fas', 'play']} /> Video o vánocích</VideoBtn>&nbsp;<VideoBtn videoId='HYSbTdUOQ1Y'><FontAwesomeIcon icon={['fas', 'play']} /> Video o investicích</VideoBtn>
                            </div>
                        </div>
                        <p className='label'>Kategorie základních úkolů</p>
                        <div className='row'>
                            { this.renderCategory('privydelky') }
                            { this.renderCategory('vanoce') }
                            { this.renderCategory('financni_rezervy_a_investice') }
                        </div>
                        <hr/>
                        <p className='label'>Kreativní úkoly</p>
                        { creativeTasks }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions,
        creativeTasks: state.creativeTasks
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        submitCreativeTask: submitCreativeTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Categories);
